module.exports = __webpack_public_path__ + "media/images/emblems/Neftenbach-blazon-ef424b29b18cf9a7f2a60d9580d35be5.svg";